import { Params } from '@angular/router';
import { Tab } from '@shared/interfaces/tabs/tabs.interface';
import { ROUTES } from '@shared/consts/routes';

export enum NavigationMenu {
  home = 'home',
  catalog = 'catalog',
  cart = 'cart',
  orders = 'orders',
  profile = 'profile',
}

export interface NavigationMenuItem extends Tab {
  value: NavigationMenu;
  icon?: string;
  route: string;
  iconId?: string;
  queryParams?: Params;
}

export const NavigationMenuItems: NavigationMenuItem[] = [
  {
    title: 'NAVIGATION_MENU.HOME',
    value: NavigationMenu.home,
    route: ROUTES.HOME,
    iconId: 'main-page',
  },
  {
    title: 'NAVIGATION_MENU.CATALOG',
    value: NavigationMenu.catalog,
    icon: 'pi pi-th-large catalog-icon',
    route: ROUTES.CATALOG_MENU,
  },
  {
    title: 'NAVIGATION_MENU.ORDERS',
    value: NavigationMenu.orders,
    route: ROUTES.ORDERS,
    iconId: 'orders',
  },
  {
    title: 'NAVIGATION_MENU.CART',
    value: NavigationMenu.cart,
    icon: 'pi pi-shopping-cart',
    route: ROUTES.CART,
  },
  {
    title: 'NAVIGATION_MENU.PERSONAL_ACCOUNT',
    value: NavigationMenu.profile,
    route: ROUTES.USER_PROFILE,
    iconId: 'user',
  },
];
